// This icon file is generated automatically.
var PPlayCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }, { "tag": "path", "attrs": { "d": "M10.24 6.8L5.61 3.44a.25.25 0 00-.4.2v6.72c0 .2.24.32.4.2l4.63-3.36c.14-.1.14-.3 0-.4zM6.22 8.9V5.1L8.82 7l-2.6 1.9z" } }] }] }, "name": "p-play-circle", "theme": "outlined" };
export default PPlayCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPlayCircleOutlined.js
// module id = 3536
// module chunks = 0